<template>
  <div>
    <navigation-bar></navigation-bar>
    <div class="main">
      <el-row>
        <!-- 左侧导航栏 -->
        <el-col :span="4">
          <div class="sidebar">
            <div class="sidebar_title">{{data.name}}</div>
            <!-- <div class="sidebar_item" :class='{ active:index===number}' v-for="(item,index) in dataList" :key="index" @click="change(index)">
              {{item.title}}
            </div> -->
            <!-- <div v-for="(item,index) in dataList" :key="index">
              <div>{{item.title}}</div>
              <div v-for="(value,i) in item.children" :key="i">
                {{value.title}}
              </div>
            </div> -->
            <el-menu
              default-active="0-0"
              class="el-menu-vertical-demo">
              <el-submenu :index="index+''" v-for="(item,index) in dataList" :key="index">
                <template slot="title">
                  <span>{{item.title}}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item :index="index+'-'+i" v-for="(value,i) in item.children" :key="i" @click="showContent(value)">
                    {{value.title}}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
          </div>
        </el-col>
        <!-- 内容 -->
        <el-col :span="16">
          <div class="content">
            <mavon-editor 
              :value="content"
              class="mavon"
              :subfield = "false"
              :defaultOpen = "'preview'"
              :toolbarsFlag = "false"
              :editable="false"
              :scrollStyle="true"
              :ishljs = "true"/>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryChapterByCategoryId } from '@/api/console/document.js'
import NavigationBar from '../../../components/console/navigationBar.vue'
export default {
  components: {
    NavigationBar
  },
  data() {
    return {
      typeList: [],
      number: 0,
      data: {},
      dataList: [],
      //content
      content: '',
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.data = JSON.parse(this.$route.query.data);
      // console.log(this.data);
      let id = this.data.id;
      let res = await queryChapterByCategoryId(id);
      let arr = [];
      res.data.list.forEach((e) => {
        if(e.parentId === 0) {
          arr.push({
            ...e,
            key: Date.now(),
            children: [],
          });
        } else {
          arr.forEach((value) => {
            if(e.parentId == value.chapterId) {
              value.children.push({
                ...e,
                key: Date.now()
              })
            }
          })
        }
      });
      this.dataList = arr;
      // console.log('---------------------------');
      // console.log(this.dataList);
      //自动显示第一个内容
      let value = this.dataList[0].children[0].content;
      this.showContent(value)
    },
    showContent(data) {
      this.content = data.content;
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.main {
  margin-top: 80px;
  .sidebar {
    width: 80%;
    height: 1200px;
    color: #4F4F4F;
    border-right: 1px solid #E5E5E5;
    .sidebar_title {
        height: 79px;
        border-bottom: 1px solid #E5E5E5;
        text-align: center;
        line-height: 79px;
    }
    .sidebar_item {
      height: 47px;
      font-size: 14px;
      text-align: center;
      line-height: 47px;
    }
    .active {
      background-color: #F8F9FF;
      color: #537EEE;
      border-right: 4px solid #537EEE;
    }
    .sidebar_item:hover {
      cursor: pointer;
      background-color: #F8F9FF;
      color: #537EEE;
    }
    /deep/.el-menu-item.is-active {
      border-right: 4px solid #537EEE;
      color: #537EEE;
    }
  }
  .content {
    margin-top: 20px;
    border: 1px solid #E5E5E5;
    .mavon {
      position: relative;
      z-index: 1;
    }
  }
}
</style>